import ActionTypeCliente from "../ActionTypeCliente";

export default class FinalizarComando extends ActionTypeCliente {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }
}
